import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Review from "./components/review";

// Сколько последних отзывов показываем на главной. Остальные — на /reviews.
const PREVIEW_COUNT = 3;

// reviews — только отзывы с текстом (скриншоты живут в карусели),
// total — сколько отзывов всего: на кнопке «все отзывы» должно стоять полное
// число, иначе человек решит, что их всего три.
export const ReviewsPart = ({ reviews, total = reviews.length }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="mt-10 lg:mt-0 lg:col-start-6 lg:col-span-7">
      <div className="flow-root">
        <div className="divide-y divide-kj-line">
          {reviews.slice(-PREVIEW_COUNT).map((review) => (
            <Review
              key={review._id}
              name={review.name}
              date={review.date}
              stars={review.stars}
              comment={review.comment}
              photos={review.photos}
            />
          ))}
        </div>
      </div>

      {total > Math.min(reviews.length, PREVIEW_COUNT) && (
        <button
          type="button"
          onClick={() => navigate("/reviews")}
          className="mt-2 w-full sm:w-auto rounded-md border border-kj-sky/40 px-5 py-2.5 text-xs sm:text-sm font-bold uppercase tracking-[0.12em] text-kj-sky hover:bg-kj-sky hover:text-kj-dark transition-colors"
        >
          {t("reviews.allBtn")} ({total}) →
        </button>
      )}
    </div>
  );
};
